import React, { useEffect, useState } from 'react';
import classes from './OfferPromoModal.module.scss';
import {
  parseOfferPromoState,
  shouldShowOfferPromo
} from './offerPromoVisibility';

const STORAGE_KEY = 'tvpOfferPromo';
const SHOW_DELAY_MS = 1000;
const OFFER_URL = 'https://tvp.uspartner.pl';

const PRODUCTS = [
  {
    key: 'zagraniczne',
    name: 'Podróże zagraniczne',
    description: 'Bezpieczne wakacje z telekonsultacją za granicą',
    image: 20,
    href: 'https://tvp.uspartner.pl/zagraniczne/opis/'
  },
  {
    key: 'assistance',
    name: 'Moto Assistance Europa',
    description: 'Pomoc na drodze 24/7 — nie martw się awarią',
    image: 21,
    href: 'https://tvp.uspartner.pl/assistance/opis/'
  },
  {
    key: 'edu',
    name: 'NNW szkolne',
    description: 'Ochrona dziecka przez cały rok — w szkole i poza nią',
    image: 22,
    href: 'https://tvp.uspartner.pl/edu/opis/'
  }
];

const readStateRaw = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

const patchState = (patch) => {
  try {
    const state = parseOfferPromoState(
      window.localStorage.getItem(STORAGE_KEY)
    );

    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...state, ...patch })
    );
  } catch (error) {
    // localStorage zablokowany — popup wróci przy kolejnym wejściu
  }
};

const OfferPromoModal = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!shouldShowOfferPromo(new Date(), readStateRaw())) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      patchState({ shownAt: Date.now() });
      setVisible(true);
    }, SHOW_DELAY_MS);

    return () => window.clearTimeout(timer);
  }, []);

  if (!visible) {
    return null;
  }

  // Zamyka wyłącznie przycisk X — klik w tło, Escape ani wybór produktu
  // nie chowają banera (decyzja biznesowa, rozmowa 2026-07-07).
  const dismiss = () => {
    patchState({ dismissedAt: Date.now() });
    setVisible(false);
  };

  // Klik w produkt zostawia baner otwarty (oferta otwiera się w nowej
  // karcie), ale zapisuje konwersję — kolejne wizyty mają 45 dni ciszy.
  const convert = () => {
    patchState({ clickedAt: Date.now() });
  };

  return (
    <div className={classes.overlay} role="presentation">
      <div
        className={classes.card}
        role="dialog"
        aria-modal="true"
        aria-label="Prywatne ubezpieczenia dla pracowników i współpracowników TVP">
        <button
          type="button"
          className={classes.closeButton}
          onClick={dismiss}
          aria-label="Zamknij">
          ×
        </button>
        <div className={classes.header}>
          <span className={classes.badge}>Prywatne ubezpieczenia</span>
          <h2 className={classes.headline}>
            <span className={classes.highlight}>Obniżone stawki</span> dla
            pracowników i&nbsp;współpracowników{' '}
            <span className={classes.highlight}>TVP</span>
          </h2>
        </div>
        <div className={classes.tiles}>
          {PRODUCTS.map((product) => (
            <a
              key={product.key}
              className={classes.tile}
              href={product.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={convert}
              style={{
                backgroundImage: `url('${process.env.PUBLIC_URL}/tvp/dashboard/${product.image}.jpg')`
              }}>
              <span className={classes.tileOverlay} />
              <span className={classes.tileTitle}>{product.name}</span>
              <span className={classes.tileContent}>
                <span className={classes.tileDescription}>
                  {product.description}
                </span>
                <span className={classes.tileCta}>Sprawdź ofertę</span>
              </span>
            </a>
          ))}
        </div>
        <div className={classes.footer}>
          <p className={classes.more}>
            …a także ubezpieczenia majątkowe, pakiety weterynaryjne dla psa
            i&nbsp;kota i&nbsp;inne
          </p>
          <a
            className={classes.ctaButton}
            href={OFFER_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={convert}>
            Sprawdź szczegóły
          </a>
        </div>
      </div>
    </div>
  );
};

export default OfferPromoModal;
